import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useBusiness } from '../../contexts/BusinessContext';
import { ArrowLeft, TrendingUp } from 'lucide-react';
import { toast } from 'react-hot-toast';

const StaffDetailPage = () => {
  const { staffId } = useParams();
  const navigate = useNavigate();
  const { activeBusiness } = useBusiness();
  const [loading, setLoading] = useState(true);
  const [staffData, setStaffData] = useState(null);

  useEffect(() => {
    if (activeBusiness?.id && staffId) {
      // For now, redirect back since detail API not fully implemented
      // TODO: Implement full detail view in later phase
      toast('Staff detail view - Coming soon!', { icon: 'ℹ️' });
      setTimeout(() => {
        navigate(`/business/${activeBusiness.id}/intelligence/staff`);
      }, 1500);
    }
  }, [activeBusiness?.id, staffId, navigate]);

  return (
    <div className="p-4 sm:p-6 space-y-6">
      <button
        onClick={() => navigate(`/business/${activeBusiness.id}/intelligence/staff`)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Staff List
      </button>

      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <TrendingUp className="w-16 h-16 mx-auto mb-4 text-gray-400" />
          <p className="text-gray-600">Loading staff details...</p>
        </div>
      </div>
    </div>
  );
};

export default StaffDetailPage;
